import { configureStore } from '@reduxjs/toolkit';
import notificationReducer from './slices/notificationSlice';
import profileReducer from './slices/profileSlice';
import authReducer from './slices/authSlice';
import registerReducer from './slices/registerSlice';
import signupReducer from './slices/signupSlice';
import verificationReducer from './slices/verificationSlice';
import shipmentReducer from './slices/shipmentSlice';
import trackingReducer from './slices/trackingSlice';
import paymentReducer from './slices/paymentSlice';
import driverReducer from './slices/driverSlice';
import fleetSlice from './slices/fleetSlice';
import carrierProfileSlice from './slices/carrierProfileSlice';
import loadReducer from './slices/loadSlice';
import bidReducer from './slices/bidSlice';
import customerSlice from './adminSlice/adminCustomerSlice';

import adminAuthReducer from './adminSlice/adminAuthSlice';
import adminDriverSlice from './adminSlice/adminDriverSlice';
import fleetAdminSlice from './adminSlice/fleetAdminSlice';
import adminCargoTypeSlice from './adminSlice/adminCargoTypeSlice';
import adminVehicleMakeSlice from './adminSlice/adminVehicleMakeSlice';
import adminVehicleTypeSlice from './adminSlice/adminVehicleTypeSlice';

export const store = configureStore({
  reducer: {
    //client
    notifications: notificationReducer,
    profile: profileReducer,
    auth: authReducer,
    register: registerReducer,
    signup: signupReducer,
    verification: verificationReducer,
    shipment: shipmentReducer,
    tracking: trackingReducer,
    payments: paymentReducer,
    driver: driverReducer,
    fleet: fleetSlice,
    carrier: carrierProfileSlice,
    loads: loadReducer,
    bids: bidReducer,
    //admin
    adminAuth: adminAuthReducer,
    customer: customerSlice,
    adminDriver: adminDriverSlice,
    adminFleet: fleetAdminSlice,
    adminCargoType: adminCargoTypeSlice,
    adminVehicleMake: adminVehicleMakeSlice,
    adminVehicleType: adminVehicleTypeSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});